export default "__VITE_ASSET__659c2b45__"